(function(window, document) {
  document.addEventListener('DOMContentLoaded', function() {

    // ———— 1) Header scroll toggle ————
    var header = document.querySelector('.header-wrapper');
    if (header) {
      window.addEventListener('scroll', function() {
        header.classList.toggle('scrolled', window.scrollY > 50);
      });
    }

    // ———— Helper: open the Flow cart drawer (with slide-out animation) ————
    function openCartDrawer() {
      fetch(`/cart?view=drawer&_=${Date.now()}`)
        .then(res => res.text())
        .then(html => {
          // 1) Parse & replace the <cart-drawer> element
          const parser      = new DOMParser();
          const doc         = parser.parseFromString(html, 'text/html');
          const newDrawer   = doc.querySelector('cart-drawer');
          const oldDrawer   = document.querySelector('cart-drawer');
    
          if (!newDrawer || !oldDrawer) {
            console.warn('[dex] cart-drawer not found for replace');
            return;
          }
          oldDrawer.replaceWith(newDrawer);
    
          // 2) Wait for the component to upgrade, then fire Flow’s open event
          const openViaEventBus = () => {
            if (window.eventBus && typeof window.eventBus.emit === 'function') {
              window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
            } else {
              console.warn('[dex] eventBus.emit not available, falling back to openDrawer()');
              if (typeof newDrawer.openDrawer === 'function') {
                newDrawer.openDrawer();
              }
            }
          };
    
          if (window.customElements && customElements.whenDefined) {
            customElements
              .whenDefined('cart-drawer')
              .then(openViaEventBus)
              .catch(() => setTimeout(openViaEventBus, 50));
          } else {
            // older browsers — just defer a tick
            setTimeout(openViaEventBus, 50);
          }
        })
        .catch(err => {
          console.error('[dex] fetch/replace drawer failed, falling back', err);
          // fallback: open whatever drawer is already in the DOM
          const fallback = document.querySelector('cart-drawer');
          if (fallback && typeof fallback.openDrawer === 'function') {
            fallback.openDrawer();
          }
        });
    }


    // ———— 2a) Instant Builder’s “add to cart” event ————
    document.addEventListener('instant:add-to-cart', function() {
      console.log('[dex] instant:add-to-cart fired');
      openCartDrawer();
    });

    // ———— 2b) “Cart” icon in the header ————
    document.body.addEventListener('click', function(evt) {
      var link = evt.target.closest('a[data-instant-action-type="open-cart"]');
      if (!link) return;
      evt.preventDefault();
      console.log('[dex] intercepted open-cart click');
      openCartDrawer();
    });

  });
})(window, document);
